export const SET_LOOKUPS = 'SET_LOOKUPS'
export const RESET_LOOKUPS = 'RESET_LOOKUPS'
export const UPSERT_LOOKUP = 'UPSERT_LOOKUP'
export const DELETE_LOOKUP = 'DELETE_LOOKUP'
export const SET_GROUPS = 'SET_GROUPS'
export const UPSERT_GROUP = 'UPSERT_GROUP'
export const SET_TIMEZONES = 'SET_TIMEZONES'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_STATE_PROVINCES = 'SET_STATE_PROVINCES'
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const SET_KEYWORDS = 'SET_KEYWORDS'
export const RESET_INSURANCE_DATA = 'RESET_INSURANCE_DATA'
export const SET_INSURANCE_DATA = 'SET_INSURANCE_DATA'
export const SET_INSURANCE = 'SET_INSURANCE'
export const SET_INSURANCE_LOOKUP = 'SET_INSURANCE_LOOKUP'
export const SET_BRAND = 'SET_BRAND'



// WEBPACK FOOTER //
// ./src/store/modules/lookups/types.js